import { createSlice } from '@reduxjs/toolkit';

export const anyPendingAction = action => !!action.type.endsWith('/pending');

export const anyFullfilledAction = action =>
    !!action.type.endsWith('/fulfilled');

export const anyRejectedAction = action => !!action.type.endsWith('/rejected');

const initialState = {
    isLoading: false,
};

export const sharedSlice = createSlice({
    name: 'sharedSlice',
    initialState,
    reducers: {
        setLoader: (state, action) => ({
            isLoading: action.payload,
        }),
    },
    extraReducers: builder => {
        builder
            .addMatcher(anyPendingAction, state => {
                state.isLoading = true;
            })
            .addMatcher(anyFullfilledAction, state => {
                state.isLoading = false;
            })
            .addMatcher(anyRejectedAction, state => {
                state.isLoading = false;
            });
    },
});

export const { setLoader } = sharedSlice.actions;
export default sharedSlice.reducer;
